module.exports = __webpack_public_path__ + "static/media/Geschirrtuch_50x70.121d0d30.png";